export const SET_LIST_DATA = "SET_CANCELLATION_REASON_LIST_DATA";
export const SET_LOADING_DATA = "SET_CANCELLATION_REASON_LOADING_DATA";
export const SET_LIST_PAGINATION = "SET_CANCELLATION_REASON_LIST_PAGINATION";
export const SET_LIST_FILTER = "SET_CANCELLATION_REASON_LIST_FILTER";
export const RESET_REDUCER = "RESET_CANCELLATION_REASON_REDUCER";
